export class TimeUtils {
  static extractMinutesFromDuree(duree: string): number {
    const splitTime = duree.split(":");

    return parseInt(splitTime[0]) * 60 + parseInt(splitTime[1]);
  }

  static pad(num) {
    if (num < 10) {
      return "0" + num;
    } else {
      return "" + num;
    }
  }

  static formatTime(minutes): string {
    return [
      this.pad(Math.floor(minutes / 60)),
      this.pad(Math.floor(minutes) % 60),
    ].join(":");
  }

  static sumTimes(times: string[]): string {
    let temp = 0;

    times.forEach((t) => {
      if (t) {
        temp += this.extractMinutesFromDuree(t);
      }
    });

    return this.formatTime(temp);
  }

  static diffTimes(time1: string, time2: string): string {
    let temp = 0;

    if (
      this.extractMinutesFromDuree(time1) -
        this.extractMinutesFromDuree(time2) >
      0
    ) {
      temp =
        this.extractMinutesFromDuree(time1) -
        this.extractMinutesFromDuree(time2);
    } else {
      temp =
        this.extractMinutesFromDuree(time2) -
        this.extractMinutesFromDuree(time1);
    }

    return this.formatTime(temp);
  }

  static bizDays(d1, d2) {
    d1 = new Date(d1);
    d2 = new Date(d2);
    let interval = Math.abs(d1 - d2);
    let days = Math.floor(interval / 8.46e7);
    let tem = days;
    let weeks = Math.floor(days / 7);
    let temp = tem;
    let wd1 = d1.getDay();
    let wd2 = d2.getDay();
    if (wd1 == 6) {
      tem -= 2;
    } else if (wd1 == 0) {
      tem -= 1;
    }
    if (wd2 == 0) {
      tem -= 1;
    }
    let diff = this.holBetween(d1, d2);
    tem -= diff[0][0];
    return weeks * 5 + tem;
  }

  static getdayOffset(y, wot) {
    let month, count, D, temp;
    if (wot.length > 3) {
      if (y < wot[3]) {
        return false;
      }
      if (wot[4] && y > wot[4]) {
        return false;
      }
    }
    const day = wot[1];
    if (wot[0] == "last") {
      month = wot[2];
      count = -1;
    } else {
      count = wot[0] - 1;
      month = wot[2] - 1;
    }
    D = new Date(y, month, 1);
    while (D.getDay() != day) {
      D.setDate(D.getDate() + 1);
    }
    D.setDate(7 * count + D.getDate());
    return [D.getMonth(), D.getDate()];
  }

  static getHolidays(year) {
    year = year || new Date().getFullYear();
    if (this.holidays["y_" + year]) {
      return this.holidays["y_" + year];
    }

    let hol = [
      // months are indexed by +1
      ["New Years Day", [1, 1]],
      ["fete du travail", [5, 1]],
      ["8 mai ", [5, 8]],
      ["fete nat", [7, 14]],
      ["Armistice", [11, 11]],
      ["Noel", [12, 25]],
    ];

    return this.setHolArray(year, hol);
  }

  static holBetween(d1, d2) {
    let A = [],
      tem,
      day,
      count = 0;
    while (d2 - d1 > 0) {
      d1.setDate(d1.getDate() + 1);
      tem = d1.isHoliday();
      if (!tem) {
        continue;
      }
      A.push(tem);
      day = d1.getDay();
      if (day != 0 && day != 6) {
        ++count;
      }
    }
    return [count, A];
  }

  static holidays() {}

  static setHolArray(y, hol) {
    let L = hol.length;
    let A = [],
      name,
      temp;
    for (let i = 0; i < 12; i++) {
      A[i] = [];
    }
    for (let i = 0; i < L; i++) {
      name = hol[i][0];
      temp = hol[i][1];
      if (!temp) {
        continue;
      }
      if (temp.length >= 3) {
        temp = this.getdayOffset(y, temp);
      } else {
        temp[0] -= 1;
      }
      A[temp[0]][temp[1]] = name;
    }
    return A;
  }

  static isHoliday() {
    let y = new Date().getFullYear();
    let ys = "y_" + y;
    if (!this.holidays[ys]) {
      this.holidays[ys] = this.getHolidays(y);
    }
    let hol = this.holidays[ys];
    let m = new Date().getMonth();
    let d = new Date().getDate();
    if (hol[m] && hol[m][d]) {
      return hol[m][d];
    }
    return false;
  }

  static addbizDays(D: Date, n) {
    let num = Math.abs(n);
    let tem,
      count = 0;
    let dir = n < 0 ? -1 : 1;
    while (count < num) {
      D = new Date(D.setDate(D.getDate() + dir));
      if (this.isHoliday()) {
        continue;
      }
      tem = D.getDay();
      if (tem != 0 && tem != 6) {
        ++count;
      }
    }
    return D;
  }
}
